<script>
import {defineComponent} from 'vue'
import playground from "../../../mixins/playground/playground";
import Response from "./ResultadoApi.vue";
import numeroProcesso from "../../../mixins/playground/numeroProcesso";

export default {
  name: "ProcessoResumoIA",
  mixins:[playground, numeroProcesso],
  components: { Response },
  computed: {
    colunas() {
      return [
        { key: "numeroCnj", label: "Número CNJ", isVisible: false },
        { key: "conteudo", label: "Resumo", isVisible: true },
        { key: "atualizadoEm", label: "Data da última atualização", isVisible: true },
      ];
    }
  },
}
</script>

<template>
  <div>
    <form id="form-playground-processo-resumo" class="form-playground" @submit.prevent="consultar">
      <div class="space-y-2">
        <label for="numero_cnj" class="font-medium text-sm">Número CNJ</label>
        <input
          id="numero_cnj"
          name="numero_cnj"
          v-model="numero"
          class="input is-large px-2 rounded-md block"
          type="text"
          v-mask="'#######-##.####.#.##.####'"
          placeholder="0000000-00.0000.0.00.0000"
          autofocus="autofocus"
        />
      </div>
    </form>

    <div class="custo-small">
      <slot name="custo"></slot>
    </div>

    <Btn
      class="btn playground-button consultar-button"
      type="button"
      :loading="$wait.is(`fetching_${identificador}`)"
      :disabled="$wait.is(`fetching_${identificador}`) || inputInvalido"
      @click="consultar"
    >
      <p class="m-0 font-semibold">Consultar</p>
    </Btn>

    <Response
      v-if="response"
      :responseApi="response"
      :identificador="identificador"
      :key="identificador"
      :logIds="logIds"
      :lista-formatada="itens"
      :colunas="colunas"
    >
    </Response>
  </div>
</template>

<style scoped lang="stylus" src="./playground.styl">

</style>
